var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9581 5.94247C15.8559 5.65074 15.5808 5.45463 15.2716 5.45463H10.5451L8.68097 0.473039C8.5746 0.1888 8.3028 0.000976562 7.99945 0.000976562C7.6961 0.000976562 7.42436 0.1888 7.31878 0.473039L5.45462 5.45463H0.727355C0.418178 5.45463 0.143103 5.64992 0.0408623 5.94247C-0.061378 6.2342 0.0325496 6.5583 0.274406 6.75113L4.08334 9.78131L2.3347 14.91C2.23665 15.1976 2.32803 15.5167 2.56409 15.7087C2.7993 15.9007 3.13008 15.9256 3.39272 15.771L7.99536 13.0567L12.7285 15.8957C12.844 15.9655 12.9736 15.9996 13.1025 15.9996C13.1033 15.9996 13.1049 15.9996 13.1066 15.9996C13.5072 15.9863 13.8371 15.6746 13.8371 15.2723C13.8371 15.151 13.808 15.0363 13.7549 14.9357L11.9206 9.77713L15.7246 6.75107C15.9664 6.55909 16.0603 6.23414 15.9581 5.94241V5.94247Z",
    fill: "#6B6C7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavStar);
export default __webpack_public_path__ + "static/media/favStar.7d8151742348477568a0a13c66563c0c.svg";
export { ForwardRef as ReactComponent };